<div class="min-h-screen w-full flex flex-col">
    <app-header></app-header>
    <app-toolbar></app-toolbar>
    <app-submenu [items]="subMenuItems" [backBgGray]="true"></app-submenu>
    <div class="min-h-screen bg-[#f6f6f6] pb-20 pt-10">
        <section
            class="bg-white border border-[#f0f0f0] rounded-[15px] mx-auto w-[95%] max-w-[1200px] p-2 shadow-[1px_1px_20px_0px_rgba(0,0,0,0.1)]">
            <div class="flex justify-center mt-4 mb-5">
                <div class="search w-full max-w-[300px]">
                    <div class="search-box flex align-middle pl-8 w-full bg-[#f0f0f0] rounded-[10px] h-10">
                        <input #filter [(ngModel)]="searcherCriteria" (input)="onSearchInput($event)"
                            class="form-control" placeholder="BUSCAR POR REFERENCIA/CLIENTE" />
                    </div>
                </div>
            </div>
            <div class="">
                <p-table #dt [value]="filteredInvoices" styleClass="p-datatable-striped" dataKey="reference"
                    [paginator]="true" [rows]="10" [lazy]="true" [totalRecords]="totalRecords"
                    (onLazyLoad)="loadInvoices($event)" [loading]="loading">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="text-black font-bold text-nowrap">
                                Nro de factura 
                            </th>
                            <th  class="text-black font-bold w-36 text-nowrap">
                                Monto 
                            </th>
                            <th class="text-black font-bold w-36 text-nowrap">
                                Métodos de pago
                            </th>
                            <th  class="text-black font-bold text-nowrap">
                                Cliente 
                            </th>
                            <th  class="text-black font-bold text-nowrap">
                                Fecha de emisión 
                            </th>
                            <th class="text-black font-bold text-nowrap">Acciones</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-invoice let-i="rowIndex" let-expanded="expanded">
                        <tr appButtonsHoverTable>
                            <td>
                                <ng-container *ngIf="invoice.reference_null">
                                    <span class="text-black font-bold whitespace-nowrap">
                                        {{ invoice.reference_null }}
                                    </span>
                                    <span class="block text-black font-bold whitespace-nowrap">
                                        (Factura anulada: {{ invoice.reference }})
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="!invoice.reference_null">
                                    <span class="text-black font-bold whitespace-nowrap">
                                        {{ invoice.reference }}
                                    </span>
                                </ng-container>

                            </td>
                            <td>{{ invoice.total | currency : "EUR" }}</td>
                            <td>{{ utils.getPaymentMethodsFromInvoice(invoice) }}</td>
                            <td>{{ invoice.customer_name }}</td>
                            <td>{{ invoice.invoice_created_at | date:'dd/MM/yyyy - hh:mm a' }}</td>
                            <td class="text-center">
                                <div class="hide-buttons max-w-[120px]">
                                    <ng-container *ngIf="utils.validatePermission('see_invoices')">
                                        <button pButton type="button"
                                            class="bg-blue-600 rounded-md p-1 text-white text-xs font-bold m-1 text-nowrap block mx-auto"
                                            (click)="download(invoice.id, invoice)"
                                            pTooltip="Descargar factura" tooltipPosition="left" [disabled]="
                                          utils.validatePermission('create_invoice') == false &&
                                          utils.validatePermission('download_invoice') == false
                                        ">
                                            Ver factura
                                        </button>
                                        <button *ngIf="invoice.reference_null" pButton type="button"
                                            class="bg-blue-600 rounded-md p-1 text-white text-xs font-bold m-1 text-nowrap block mx-auto"
                                            (click)="download(invoice.id, invoice, true)"
                                            pTooltip="Descargar factura original" tooltipPosition="left" [disabled]="
                                          utils.validatePermission('create_invoice') == false &&
                                          utils.validatePermission('download_invoice') == false
                                        ">
                                            Ver factura original
                                        </button>
                                    </ng-container>
    
                                    <ng-container
                                        *ngIf="(utils.validateRol('manager') || utils.validateRol('super-admin'))">
                                        <button
                                            class="bg-red-500 text-white px-1 rounded-md h-7 text-center font-bold m-1 text-xs items-center text-nowrap block mx-auto"
                                            [routerLink]="[
                                        '/panel/payments/invoices/edit',
                                        invoice.id
                                      ]">
                                            Editar factura
                                        </button>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="(utils.validateRol('manager') || utils.validateRol('super-admin')) && !invoice.reference_null">
                                        <button
                                            class="bg-red-500 text-white px-1 rounded-md h-7 text-center font-bold m-1 text-xs items-center text-nowrap block mx-auto"
                                            (click)="cancelInvoice(invoice)"    
                                        >
                                            Anular
                                        </button>
                                    </ng-container>
                                </div>
                            </td>
                        </tr>
                    </ng-template>

                </p-table>
                <ng-template #noData>
                    <div *ngIf="filteredInvoices && filteredInvoices.length === 0"
                        class="mt-5 flex justify-center items-center w-full bg-slate-200 border border-dashed border-slate-500 rounded-xl hover:cursor-pointer p-40">
                        <h1 class="text-center text-2xl text-slate-500">
                            Genera una nueva factura<br />
                        </h1>
                    </div>
                </ng-template>

            </div>
        </section>
    </div>
</div>